import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MentationAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-mentation-slot',
    templateUrl: './mentation-slot.component.html',
    styleUrl: './mentation-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MentationSlotComponent implements SheetSlotComponentBase {

	action!: MentationAction;
	value!: string | null;

	@Input('action') set updateAction(action: MentationAction | null) {
		this.action = action as MentationAction;
		this.value = this.action.mentationScore?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}
